export const PREMIUM_FEATURES = [
  'All 128 civics questions, with explanations',
  'Unlimited mock interviews until you feel ready',
  'Track your progress by category',
  'Cancel anytime',
];
